import React, { useState, useEffect } from "react";
import CloudCost from './CloudCost';
import APIRequests from './APIRequests';
import heroImg1 from '../assets/hero.svg';
import heroImg2 from '../assets/cicd.png';
import heroImg3 from '../assets/stock-12.png';
import heroImg4 from '../assets/cloud.png';
import heroImg5 from '../assets/monitor.png';
import "../styles/FlipImage.css";
import DialogueCardSection from "./DialogueCardSection";

const imageData = [
  { image: `${heroImg1}`,
   cloud: <CloudCost />,
    api: <APIRequests /> 
  },
  {
      image: heroImg2,
      cloud: <DialogueCardSection index={2} />,
      api: <DialogueCardSection index={3} />
  },
  {
    image: heroImg3,
    cloud: <DialogueCardSection index={4} />,
    api: <DialogueCardSection index={5} />
  },
  {
    image: heroImg4,
    cloud: <DialogueCardSection index={0} />,
    api: <DialogueCardSection index={1} />
  },
  {
    image: heroImg5,
    cloud: <DialogueCardSection index={6} />,
    api: <DialogueCardSection index={7} />
  }
];


const HeroSection: React.FC = () => {

  const [curIndex, setCurIndex] = useState(1);
  const [preIndex, setPreIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFlipped((prev) => !prev);
      const newCur = (curIndex + 1) % imageData.length;
      setCurIndex(newCur);

      setTimeout(() => {

        if (isFlipped) {
          setNextIndex(newCur);
          console.log("nextIndex", newCur)
        } else {
          setPreIndex(newCur);
          console.log("preIndex", newCur)
        }

      }, 1000); 
    }, 5000);

    return () => clearInterval(interval);
  }, [curIndex, isFlipped]);

  const front =  imageData[preIndex] ;
  const back =  imageData[nextIndex];




  return (
    <div style={{ height: '100%', paddingBottom: '70px' }} >
      <div className="mx-auto p-8 md:p-12">
        <div className="flex flex-col lg:flex-row">
          {/* Left Column */}
          <div className="w-full lg:w-1/2 pr-0 lg:pr-8 mb-12 lg:mb-0">
            <h2 className="text-black text-3xl md:text-4xl font-bold mb-12" style={{ fontSize: '46px', whiteSpace: 'nowrap' }}>
              Revolutionizing Traditional Pipelines
            </h2>

            <div className="text-black" style={{ marginTop: '100px' }}>
              <div className="text-5xl md:text-8xl mb-4" style={{ fontWeight: '100' }}>From</div>
              <div className="text-5xl md:text-8xl mb-2" style={{ fontWeight: '100' }}>Development <span className="text-5xl md:text-8xl font-bold">to</span></div>
              <div className="text-5xl md:text-8xl" style={{ fontWeight: '100' }}>Deployment</div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 relative flex hero-img" style={{
            justifyContent: 'flex-end',
          }}>
            <div className="flip-carousel">
              <div className={`flip-card ${isFlipped ? "flipped" : ""}`}>
                {/* Front Face */}
                <div className="flip-face front">
                  <img src={front.image} className="main-image" alt="front" />
                  <div className="cloud-cost-box">{front.cloud}</div>
                  <div className="api-request-box">{front.api}</div>
                </div>

                {/* Back Face */}
                <div className="flip-face back">
                  <img src={back.image} className="main-image" alt="back" />
                  <div className="cloud-cost-box">{back.cloud}</div>
                  <div className="api-request-box">{back.api}</div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection; 